import axios from "axios";

import { useMutation, useQueryClient } from "@tanstack/react-query";


import { create } from "zustand";
import { useJWTStore } from "../Zustand";

type gptHistoryStoreType = {
  history: string[];
  setHistory: (string: string) => void;
  resetHistory: () => void;
  messageHistory: {
    role: "user" | "assistant";
    content: string;
    error?: Error;
  }[];
  setMessageHistory: (message: {
    role: "user" | "assistant";
    content: string;
    image?: string;
    error?: Error;
  }) => void;
};

export const useGptHistoryStore = create<gptHistoryStoreType>()((set) => ({
  history: [],
  messageHistory: [],

  resetHistory: () => set({ history: [], messageHistory: [] }),
  setHistory: (str: string) =>
    set((state) => ({ ...state, history: [...state.history!, str] })),
  setMessageHistory: (message: {
    role: "user" | "assistant";
    content: string;
  }) =>
    set((state) => ({
      ...state,
      messageHistory: [...state.messageHistory!, message],
    })),
}));

const UBI_API_ADDRESS = "https://ubisiveaifunctions.azurewebsites.net/api/";

const GPT_TOKEN = "xPG7jMyq4dVxVxknAl0up4AwtYad47moEys9K4FtAiU9AzFufez_jw==";

const VISION_TOKEN = "qlqBFhLhLMUS3B_GuVp1ku_3Tn3BfVPEfNPYVzxRM9r4AzFuRzCfXg==";

const DALLE_TOKEN = "h2VOHu_a1pYlBEDkLm5_TNjtZo6GvN6uH_5RE9JrhBy1AzFuGst0Ng==";
const ubiAiInstance = axios.create({
  baseURL: UBI_API_ADDRESS,
});

ubiAiInstance.interceptors.request.use((config) => {
  const { jwt } = useJWTStore.getState()

  if (jwt) {
    config.headers.set("deeprealityjwt", jwt);
  }

  return config;
});

export const useUbiApiChatCompletion = () => {
  const { history, setHistory, setMessageHistory } = useGptHistoryStore();

  return useMutation({
    mutationKey: ["UbisiveChatCompletion"],

    mutationFn: async (prompt: string) => {
      if (prompt) {
        setHistory(prompt);

        setMessageHistory({ role: "user", content: prompt });

        const payload: payload = {
          input: prompt,
          history: history,
        };

        return ubiAiInstance
          .request({
            url: "ChatGPT",
            method: "post",
            data: JSON.stringify(payload),
            headers: { "x-functions-key": GPT_TOKEN },
          })
          .then((resp) => {
            setHistory(resp.data);
            setMessageHistory({ role: "assistant", content: resp.data });

            return resp.data;
          })
          .catch((err) => {
            setMessageHistory({
              role: "assistant",
              error: err,
              content: "errore",
            });
            throw err;
          });
      } else throw new Error("Missing prompt");
    },
  });
};

type payload = {
  input: string;
  history?: string[];
  engine?: string;
  system?: string;
};

export function useUbiVision() {
  const { setHistory, setMessageHistory } = useGptHistoryStore();

  return useMutation({
    mutationKey: ["UbisiveVision"],
    mutationFn: async (variables: { image: string; prompt?: string }) => {
      setHistory("descrivimi cosa vedi");
      setMessageHistory({
        role: "user",
        content: variables.prompt ?? "Descrivimi cosa vedi",
        image: variables.image,
      });

      const payload = {
        image: variables.image,
        input: variables.prompt ?? "sapresti riconoscere questo luogo?",
      };

      return ubiAiInstance
        .post("Vision", JSON.stringify(payload), {
          headers: { "x-functions-key": VISION_TOKEN },
        })
        .then((resp) => {
          setHistory(resp.data);
          setMessageHistory({ role: "assistant", content: resp.data });
          return resp.data;
        })
        .catch((e) => {
          throw e;
        });
    },
  });
}

export function useDallE() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["UbisiveDallE"],

    mutationFn: async (variables: {
      prompt: string;
      numberOfImages?: number;
    }) => {
      const payload = {
        input: variables.prompt,
        count: 4,
        model: "dall-e-2",
        // size: "1024x1024",
        format: "b64_json",
      };

      console.debug("asking dallE " + variables.prompt);

      return ubiAiInstance
        .post("DallE", JSON.stringify(payload), {
          headers: {
            "x-functions-key": DALLE_TOKEN,
          },
        })
        .then((res) => {
          let response: string[] = res.data;

          const newResponse = response.map((el) => {
            const randIndx = Math.floor(100000000 + Math.random() * 900000000);
            return { url: el, index: randIndx };
          });

          queryClient.setQueryData(
            [
              "DallEResult",
              variables.prompt.toLocaleLowerCase().replace(/\s/g, ""),
            ],
            newResponse
          );

          return newResponse;
        });
    },
  });
}
